import {
    Advertisement,
    Article,
    Bookie,
    Competition,
    Country,
    Discount,
    Event,
    HomeEvent,
    HomePromoCard,
    Market,
    Participant,
    Service,
    Sport,
    Subscription,
    TipsterType,
    User
} from '@apuestes/types';

  const initialUserState: User = {
    id: -1,
    firstname: null,
    lastname: null,
    email: '',
    alias: null,
    age: null,
    auth_provider: null,
    dni: null,
    address: null,
    telf: null,
    telegram_id: null,
    telegram_channel: null,
    twitter_id: null,
    instagram_id: null,
    country_id: null,
    username: null,
    password: null,
    email_verified_at: null,
    last_login: null,
    photo_id: null,
    verify_hash: null,
    balance: 0,
    base_id: 0,
    metrics_id: 0,
    channel_id: 0,
    wallet_id: 0,
    device_tokens: null,
    pending_messages: null,
    preferences: null,
    tipster_banner_id: 0,
    stripe_customer_id: null,
}

  const initialTipsterTypeState: TipsterType = {
    id: -1,
    name: '',
    is_free: false,
    picks_min: 0,
    services_max: 0,
    eligible: 0,
    base_id: 0,
  }

  const initialSportState: Sport = {
      id: -1,
      logo_id: null,
      name: 'sport',
      base_id: 0,
      pick_result_types: [],
      position: null,
      alternative_names: null
  }

  const initialParticipantState: Participant = {
    id: -1,
    photo_id: null,
    name: '',
    base_id: 0,
    alternative_names: null
  }

  const initialCountryState: Country = {
    id: -1,
    flag_id: null,
    name: 'country',
    base_id: 0,
    alternative_names: null
  }

  const initialDiscountState: Discount = {
    id: -1,
    tipster_id: -1,
    code: '',
    description: null,
    starts_at: new Date(),
    ends_at: null,
    amount: 0,
    percentage: 0,
    spots: 0,
    active: true,
    base_id: -1,
  }

  const initialCompetitionState: Competition = {
    id: -1,
    logo_id: null,
    countries_sports_id: -1,
    name: 'competition',
    base_id: 0,
    alternative_names: null
  }

  const initialBookieState: Bookie & {
    description?: string | null
    description_en?: string | null
  } = {
    id: -1,
    name: '',
    icon_id: null,
    url: '',
    description: null,
    description_en: null,
    is_verified: false,
    base_id: 0
  }

  const initialMarketState: Market = {
    id: -1,
    name: '',
    base_id: 0
  }

const initialAdvertisementState: Advertisement = {
    id: -1,
    title: '',
    description: '',
    url: '',
    start_date: new Date(),
    end_date: new Date(),
    base_id: 0,
    tipster_id: 0,
    image_id: 0,
    service_id: 0
}

const initialSubscriptionState: Subscription = {
    id: -1,
    starts_at: new Date(),
    ends_at: new Date(),
    plan_id: 0,
    created_at: new Date(),
}

  const initialEventState: Event = {
    id: -1,
    user_id: 0,
    manual: false,
    algolia_id: -1,
    expired: false,
    date: new Date(),
    is_live: false,
    competition_id: -1,
    base_id: -1,
    result: ''
  }

  const initialServiceState: Service = {
    id: -1,
    name: '',
    description: '',
    base_id: -1,
    logo_id: -1,
    eligible: -1,
    users_tipsters_types_id: -1,
    spots: -1,
    price: -1,
    has_bet365: false,
    paused: false,
    can_pause: false,
    can_limit_spots: false,
    can_modify_price: false,
    coins: -1,
    metrics_id: 0,
    hash: '',
  }

const initialHomePromoCardState: HomePromoCard = {
    id: -1,
    type: 'PROMO',
    title: '',
    subtitle: null,
    content: null,
    cta_label: '',
    sort_order: 0,
    url: null,
    screen: null,
    screen_params: null,
    tipster_id: null,
    service_id: null,
    article_id: null,
    image_id: null,
    start_date: null,
    end_date: null,
    base_id: 0,
}

const initialArticleState = {
    id: -1,
    article_status_id: 1,
    title: null,
    slug: null,
    excerpt: null,
    content: null,
    read_time_minutes: 4,
    cover_image_id: null,
    base_id: 0,
    category_ids: [] as number[],
} as Article & { category_ids?: number[] }

const initialHomeEventState: HomeEvent = {
    id: -1,
    title: '',
    subtitle: null,
    content: null,
    tipster_count: 0,
    pick_count: 0,
    sort_order: 0,
    url: null,
    screen: null,
    screen_params: null,
    start_date: null,
    end_date: null,
    base_id: 0,
}

  export {
    initialUserState,
    initialSportState,
    initialEventState,
    initialBookieState,
    initialMarketState,
    initialAdvertisementState,
    initialHomePromoCardState,
    initialArticleState,
    initialHomeEventState,
    initialCountryState,
    initialServiceState,
    initialDiscountState,
    initialTipsterTypeState,
    initialParticipantState,
    initialCompetitionState,
    initialSubscriptionState
  }
